module.exports = __webpack_public_path__ + "img/coach-bottom-button.3173b53a.png";